import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutRatewareTariffCodeList extends Layout {
    layoutheaderRatewareTariffCode: LayoutHeader;
    sourceRatewareTariffCodeMasterfile: DataSource;
    tableRatewareTariffCode: Table;
}
